import renderIcon from 'helpers/renderIcon';
import * as React from 'react';
const classNames = require('classnames');

type IProps = React.PropsWithChildren<{
	title?: string;
	description?: string | string[];
	usage?: 'portal' | 'admin';
	variant?: 'normal' | 'dark' | 'white' | 'active' | 'contents';
	toggleEdit?: () => void;
	readOnly?: boolean;
	className?: string;
	onClick?: (e: React.MouseEvent) => void;
}>;

const PAGESECTION_USAGE = {
	portal: '',
	admin: 'portalAdminPageSection',
};

/**
 *
 * @param props
 */
export const PortalPageSection = (props: IProps) => {
	const usage = props.usage ? PAGESECTION_USAGE[props.usage] : PAGESECTION_USAGE.portal;
	let variant = props.variant || 'normal';
	if (!props.variant && props.toggleEdit && props.readOnly) {
		variant = 'dark';
	}
	const texts = props.description ? (Array.isArray(props.description) ? props.description : [props.description]) : [];
	const titleElements: JSX.Element[] = [];
	if (props.title) {
		titleElements.push(<span key="title">{props.title}</span>);
	}
	if (props.toggleEdit) {
		titleElements.push(
			<button type="button" onClick={props.toggleEdit} className="iconBtn round" key="edit">
				{renderIcon(props.readOnly ? 'edit' : 'exit')}
			</button>,
		);
	}
	return (
		<div className={classNames('card', usage, variant, props.className)} onClick={props.onClick}>
			{titleElements.length ? (
				<>
					<h3>{titleElements}</h3>
					<hr />
				</>
			) : null}
			{texts.map((t, i) => (
				<p className="note grayGigo" key={i}>
					{t}
				</p>
			))}
			{props.children}
		</div>
	);
};
